import { render } from "./LogoBig.vue?vue&type=template&id=1c2b0042"
import script from "./LogoBig.vue?vue&type=script&lang=js"
export * from "./LogoBig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__